import { useContext } from 'react';
import cc from 'classcat';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { isMobile } from 'utils/is-mobile';
import { NewCasinoGame } from 'interfaces/new-casino';
import { PersonalizedGamesContext } from './PersonalizedGamesProvider';
import { Checkbox } from 'newcomponents/UI/Checkbox';
import './index.less';

export const PersonalizedGameCard = ({ game }: { game: NewCasinoGame }) => {
  const { games, onCheck } = useContext(PersonalizedGamesContext);

  return (
    <div
      key={game.id}
      className={cc([
        'personalizedCasinoGames-item',
        {
          selected: games?.length && games.find(item => item.id === game.id),
          'personalizedCasinoGames__item--mobile': isMobile()
        }
      ])}
      onClick={() => {
        onCheck && onCheck?.(game);
      }}
    >
      <div className="personalizedCasinoGames-item-img">
        <img
          key={game.id}
          src={`${
            SpringConfigs.CASINO_HIGH_QUALITY_PICTURES && game.icon_3
              ? game.icon_3
              : isMobile() && game.icon_1
              ? game.icon_1
              : game.icon_2
          }?v=${SpringConfigs.VERSION}`}
          alt={game.name}
          loading="lazy"
        />
      </div>
      <div className="personalizedCasinoGames-item-footer">
        <span className="personalizedCasinoGames-item-name globalEllipsis">
          {game.name}
        </span>
        <span className="personalizedCasinoGames-item-providerName">
          {game.provider_title}
        </span>
      </div>
      {games && games.find(item => item.id === game.id) ? (
        <Checkbox className="personalizedCasinoGames-item-checkbox" checked />
      ) : null}
    </div>
  );
};
